import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function XmasTree(props) {
    return (
        <SvgIcon {...props}>
            <rect
                x="6"
                y="12.9524"
                width="3.24839"
                height="3.04753"
                fill="#3F7E73"
            />
            <path d="M8 0L14 7H2L8 0Z" fill="#3F7E73" />
            <path d="M8 4L16 13H0L8 4Z" fill="#3F7E73" />
        </SvgIcon>
    );
}

XmasTree.defaultProps = {
    viewBox: '0 0 16 16',
};

export default XmasTree;
